import { render, staticRenderFns } from "./job-link-worker.component.vue?vue&type=template&id=27a63c4e"
import script from "./job-link-worker.component.ts?vue&type=script&lang=ts&external"
export * from "./job-link-worker.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27a63c4e')) {
      api.createRecord('27a63c4e', component.options)
    } else {
      api.reload('27a63c4e', component.options)
    }
    module.hot.accept("./job-link-worker.component.vue?vue&type=template&id=27a63c4e", function () {
      api.rerender('27a63c4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/job-setup/job-details/job-link-inspector/job-link-worker.component.vue"
export default component.exports